import type { DownloadInfo } from './updater'
import { Updater } from './updater'

export class GenericUpdater extends Updater {
  constructor() {
    super()
  }

  async getVersion() {
    return { name: 'web', build: '' }
  }

  /**
   * Overwrite checkForUpdates with no op
   * This updater is for web or platforms unknown where we don't want to check for updates
   */
  async checkUpdates() {
    return false
  }

  async _getPlatform() {
    return 'web'
  }

  async _downloadUpdate(_info: DownloadInfo) {
    throw new Error('Not implemented')
  }

  async installUpdate() {
    throw new Error('Not implemented')
  }

  async downloadBundle(_url: string, _version: string, _checksum: string): Promise<any> {
    throw new Error('Not implemented')
  }
}
